<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";

import DatePicker from "vue2-datepicker";
import cloneDeep from "lodash/cloneDeep";
import { required, requiredIf } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
  page: {
    title: "Fund Source",
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    FundSourceTransactions: () =>
      import(/* webpackPrefetch: true */ "@/components/tables/fundsourcetransactions"),
    ActualCashTransactions: () =>
      import(/* webpackPrefetch: true */ "@/components/tables/actual-cash-transactions"),
    FundSources: () =>
      import(/* webpackPrefetch: true */ "@/components/widgets/fundsources"),
    PrintOptions: () =>
      import(/* webpackPrefetch: true */ "@/components/modals/print-options"),
    FundSourceFavorites: () =>
      import(/* webpackPrefetch: true */ "@/components/widgets/fundsourceFavorites"),
    DisbursementModal: () =>
      import(/* webpackPrefetch: true */ "@/components/modals/disbursement-modal"),
    ObligationModal: () =>
      import(/* webpackPrefetch: true */ "@/components/modals/obligation-modal"),
    MaskedInput,
  },
  data() {
    return {
      title: "Fund Source",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Fund Source",
          active: true,
        },
      ],
      transactionType: null,
      transactionModalTitle: "",
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      selectedCluster: null,
      selectedFundSource: null,
      selectedFundSourceName: null,
      tableData: [],
      alltableData: [],
      transactionTable: [],
      prexcTable: [],
      transferOption: [],
      allTransferOption: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      clusterOptions: [],
      clusterOptionforTransfer: [],
      selectedClusterOptionForTransfer: null,
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      transactionModal: false,
      transferModal: false,
      agencyID: JSON.parse(localStorage.getItem("user")).department.deliveryUnit.office
        .campus.agencyId,

      form: {
        id: 0,
        uacs: "",
        sourceName: "",
        shortName: "",
        description: "",
        bankName: "",
        accountNumber: "",
        address: "",
        fundClusterId: null,
        expiry: Date.parse(
          new Date(Number(this.$store.getters["data/getCycle"]), 11, 31)
        ),
        hasExpiry: false,
        agencyId: 0,
        campusId: this.$store.state.data.selectedCampus.id,
        fundsAvailableSignatory: "",
        fundsAvailableSignatoryPosition: ""
      },
      transaction: {
        type: "",
        description: "",
        date: Date.now(),
        amount: "0",
        fundSourceId: null,
      },
      actual: {
        id: null,
        bank: "",
        accountNumber: "",
        uacs: "",
        sourceName: "",
        actualCashBalance: 0,
        isExpired: false,
      },
      actualCashTransactions: [],
      alert: {
        type: "",
        message: "",
      },
      modalAlert: {
        show: false,
        type: "",
        message: "",
      },
      fsModal: {
        show: false,
        title: null,
      },
      acModal: {
        show: false,
        title: "",
      },
      indexSelected: -1,
      fcOptions: [],
      cOptions: [],
      selectedcOption: null,
      sOptions: [],
      fundCluster: "",
      cycle: Number(this.$store.getters["data/getCycle"]),
      cycleSearch: "",
      fundSourceBalance: 0,
      submitted: true,
      tableBusy: false,
      toggleTables: "Transactions",
      active: [],
      isActiveLoading: false,
      expired: [],
      isExpiredLoading: false,
      favorites: [],
      favoritesBusy: false,
      isExpired: false,
      utilizationSchedule: {},
      utilizationTitle: "",
      // campusAccessList: [],
      fundClusterAccessList: [],
      selectedCampus: this.$store.state.data.selectedCampus.id,
      selectedClusterFilter: null,
      selectedCampusInfo: this.$store.state.data.selectedCampus.campusName,
    };
  },
  validations: {
    form: {
      sourceName: { required },
      shortName: { required },
    },
    fundCluster: { required },
    transaction: {
      fundSourceId: { required },
      description: { required },
      date: {
        required: requiredIf(function (data) {
          return data.transactionType === "single";
        }),
      },
      amount: { required },
    },
  },
  computed: {
    rows() {
      return this.transactionTable.length;
    },
  },
  async created() {
    this.totalRows = this.items.length;
    this.tableBusy = true;
    await this.getFundClusters();
    await this.getFavorites();
    await this.getCampuses();
    this.tableBusy = false;
  },
  methods: {
    changeCycle(cycle) {
      this.cycle = cycle;
    },
    changeCampus(data) {
      this.selectedCampus = data.id;
      this.selectedCampusInfo = data.campusName;
      this.form.campusId = data.id;
      this.selectCluster(this.selectedClusterFilter);
      this.getFavorites();
    },
    transferCampus(data) {
      this.pageLoader(true);
      const nData = {
        id: data.fundSource.id,
        uacs: data.fundSource.uacs,
        sourceName: data.fundSource.sourceName,
        shortName: data.fundSource.shortName,
        description: data.fundSource.description,
        bankName: data.fundSource.bankName,
        accountNumber: data.fundSource.accountNumber,
        address: data.fundSource.address,
        fundClusterId: data.fundSource.fundClusterId,
        expiry: data.fundSource.expiry,
        hasExpiry: data.fundSource.hasExpiry,
        campusId: data.campusId,
      };
      this.$store
        .dispatch("fundsource/UpdateFundSource", nData)
        .then((response) => {
          if (response.data.error) {
            return this.showToast(response.data.errorMessage, "error");
          }
          this.selectCluster(response.data.fundClusterId);
          this.getFavorites();
          this.pageLoader(false);
          this.showToast("Fund source successfully transfered", "success");
        })
        .catch((error) => {
          console.log(error);
          this.pageLoader(false);
          this.showToast("There was an error while transferring fund source.", "error");
        });
    },
    getCampuses() {
      this.$store.dispatch("campus/GetCampus").then((res) => {
        this.cOptions = res.data.map((item) => ({
          value: item.id,
          text: item.campusName,
        }));
        this.cOptions.unshift({
          value: null,
          text: `Select ${this.$store.state.data.GLOBAL_FROM_SCHOOL ? "Campus" : "Main Office"}...`,
        });
      });
    },
    getFundClusters() {
      this.$store
        .dispatch("fundcluster/GetFundCluster")
        .then((res) => {
          const isAdmin = this.$store.state.decrypt.isAdmin();
          if (isAdmin) {
            this.fcOptions = res.data;
          } else {
            const fcAccess = this.$store.state.decrypt
              .userAccessList()
              .find(
                (item) =>
                  item.Type.toLowerCase() === "finance" &&
                  item.Access.toLowerCase().includes("fund cluster")
              );
            if(fcAccess){
              const filterAccess = this.$store.state.decrypt
                .userAccessList()
                .filter(
                  (item) =>
                    item.Type.toLowerCase() === "finance" &&
                    item.ParentId == fcAccess.Id
                );
              filterAccess.forEach((item) => {
                this.fundClusterAccessList.push(
                  Number(item.Access.split("-")[0])
                );
              });
              this.fcOptions = res.data.filter((item) =>
                this.fundClusterAccessList.includes(item.id)
              );
            }
          }

          this.clusterOptions = this.fcOptions.map((obj) => ({
            value: obj.id,
            text: obj.cluster,
          }));
          this.clusterOptions.unshift({
            value: null,
            disabled: true,
            text: "Select Fund cluster...",
          });
          this.clusterOptionforTransfer = this.clusterOptions;
        })
        .catch((err) => {
          this.showToast(
            "Something went wrong! Cannot fetch fund clusters. Please contact your administrator.",
            "error"
          );
          // this.alert = {
          //   type: "danger",
          //   message:
          //     "Something went wrong! Cannot fetch fund clusters. Please contact your administrator.",
          // };
        });
    },
    getFavorites() {
      this.$store
        .dispatch("userfundsourcefavorite/getMyFavoriteFundSource", {
          cycle: this.cycle,
          campusId: this.selectedCampus,
        })
        .then((response) => {
          this.favorites = response.data;
        })
        .catch(() => {
          this.showToast(
            "Something went wrong! Cannot fetch favorites. Please contact your administrator.",
            "error"
          );
        });
    },
    removeFavorite(data) {
      this.$store
        .dispatch("userfundsourcefavorite/removeFavoriteFundSource", data.id)
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.message, "error");
            return;
          }
          this.showToast("Successfully removed from favorites!", "success");
          this.getFavorites();
          if (this.active && this.active.length > 0) {
            if (this.active.find((item) => item.id === data.id)) {
              this.active.find((item) => item.id === data.id).isFavorite = false;
            }
          }
          if (this.expired && this.expired.length > 0) {
            if (this.expired.find((item) => item.id === data.id)) {
              this.expired.find((item) => item.id === data.id).isFavorite = false;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.showToast(
            "Something went wrong! Cannot remove from favorites. Please contact your administrator.",
            "error"
          );
        });
    },
    addFavorite(data) {
      this.$store
        .dispatch("userfundsourcefavorite/addFundSourceFavorite", {
          fundSourceId: data.id,
        })
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.message, "error");
            return;
          }
          this.showToast("Successfully added to favorites!", "success");
          if (this.active && this.active.length > 0) {
            let act = this.active.find((item) => item.id === data.id);
            if (act) act.isFavorite = true;
          }
          if (this.expired && this.expired.length > 0) {
            let exp = this.expired.find((item) => item.id === data.id);
            if (exp) exp.isFavorite = true;
          }
          this.getFavorites();
        })
        .catch((err) => {
          console.log(err);
          this.showToast(
            "Something went wrong! Cannot add to favorites. Please contact your administrator.",
            "error"
          );
        });
    },

    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    checkExpiry(data) {
      return new Date() > new Date(data) ? true : false;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    hideTransaction() {
      this.transactionModal = false;
      this.transaction.date = Date.now();
      this.transaction.description = "";
      this.transaction.amount = "0";
      this.transaction.type = "";
    },
    saveTransaction() {
      if (this.transactionType === "transfer") {
        if (Number(this.getExactAmt(this.transaction.amount)) > this.fundSourceBalance) {
          this.modalAlert = {
            show: true,
            type: "danger",
            message: "Amount exceeds fund source balance!",
          };
          this.tableBusy = false;
          return;
        }
      }
      if (Number(this.getExactAmt(this.transaction.amount)) <= 0) {
        this.modalAlert = {
          show: true,
          type: "danger",
          message: "Amount should be greater than 0!",
        };
        this.tableBusy = false;
        return;
      }
      const selectedFSId = JSON.parse(JSON.stringify(this.selectedFundSource));
      this.tableBusy = true;
      this.$v.$touch();
      if (this.$v.transaction.$invalid) {
        this.tableBusy = false;
        return;
      } else {
        if (this.transactionType === "transfer") {
          const data = {
            fromId: this.selectedFundSource,
            toId: this.transaction.fundSourceId,
            description: this.transaction.description,
            amount: Number(this.getExactAmt(this.transaction.amount)),
          };
          this.$store
            .dispatch("fundsource/transferFundSource", data)
            .then((response) => {
              this.transactionTable = [];
              // const transactions = await this.$store.dispatch(
              //   "fundsource/GetTransactionByFundSource",
              //   selectedFSId
              // );
              this.selectedcOption = null;
              this.selectedClusterOptionForTransfer = null;
              this.$store
                .dispatch("fundsource/GetTransactionByFundSource", selectedFSId)
                .then((res) => {
                  this.transactionTable = res.data;
                });

              this.fundSourceBalance = response.data.balance;

              this.active.find((obj) => obj.id === this.selectedFundSource).balance =
                response.data.balance;
              if (this.active.find((obj) => obj.id === data.toId)) {
                this.active.find((obj) => obj.id === data.toId).balance += data.amount;
                this.active.find((obj) => obj.id === data.toId).allocated += data.amount;
              }
              this.showToast("Successfully transferred funds", "success");
              // this.alert = {
              //   type: "success",
              //   message: "Successfully transferred funds",
              // };
            })
            .catch((e) => {
              this.tableBusy = false;
              this.showToast(
                "Something went wrong! Failed to transfer funds. Please contact your administrator",
                "error"
              );
              // this.alert = {
              //   type: "danger",
              //   // message:
              //   //   "Something went wrong! Failed to transfer funds. Please contact your administrator",
              //   message: e,
              // };
              this.hideTransaction();
              this.transactionModal = false;
            });
        }
        if (this.transactionType === "single") {
          // this.transaction.date = new Date(this.transaction.date).toISOString();
          const nDate = new Date(
            new Date(this.transaction.date).getTime() -
            new Date(this.transaction.date).getTimezoneOffset() * 60 * 1000
          );

          this.transaction.date = nDate.toISOString();
          // this.transaction.amount = Number.parseFloat(this.transaction.amount);
          let nData = JSON.parse(JSON.stringify(this.transaction));
          nData.amount = Number(this.getExactAmt(nData.amount));

          this.$store
            .dispatch("fundsource/CreateFundSourceTransactions", nData)
            .then((response) => {
              this.transactionTable = [];
              // const transactions = await this.$store.dispatch(
              //   "fundsource/GetTransactionByFundSource",
              //   selectedFSId
              // );

              this.$store
                .dispatch("fundsource/GetTransactionByFundSource", selectedFSId)
                .then((res) => {
                  this.transactionTable = res.data;
                });

              this.fundSourceBalance = response.data.balance;
              if (this.active.find((obj) => obj.id === this.selectedFundSource)) {
                this.active.find((obj) => obj.id === this.selectedFundSource).balance =
                  response.data.balance;
                this.active.find((obj) => obj.id === this.selectedFundSource).allocated =
                  response.data.allocated;
              }

              if (this.favorites.find((obj) => obj.id === this.selectedFundSource)) {
                this.favorites.find((obj) => obj.id === this.selectedFundSource).balance =
                  response.data.balance;
                this.favorites.find(
                  (obj) => obj.id === this.selectedFundSource
                ).allocated = response.data.allocated;
              }

              this.tableBusy = false;
              this.hideTransaction();
              this.showToast("Successfully added transaction", "success");
              // this.alert = {
              //   type: "success",
              //   message: "Successfully added funds",
              // };
            })
            .catch((e) => {
              this.showToast(
                "Something went wrong. Cannot proceed to transactions",
                "error"
              );
              // this.alert = { type: "danger", message: e };
            });
        }
        this.transaction = {
          amount: "0",
          description: "",
          fundSourceId: null,
          date: Date.now(),
        };
        this.tableBusy = false;
        this.transactionModal = false;

        this.$forceUpdate();
        this.$v.$reset();
      }
    },
    addTransaction() {
      this.transactionModalTitle = "Add Funds";
      this.transactionType = "single";
      this.transaction.fundSourceId = this.selectedFundSource;

      this.transactionModal = true;
    },
    offsetDate(data) {
      return new Date(
        data.getTime() - new Date(data).getTimezoneOffset() * 60 * 1000
      ).toISOString();
    },
    transferFund() {
      this.transactionModalTitle = "Transfer Fund";
      this.transactionType = "transfer";
      this.transaction.fundSourceId = null;

      this.transaction.amount = this.formatNumber(this.fundSourceBalance);
      this.transactionModal = true;
    },
    addFS() {
      if (!this.selectedCluster || !this.selectedCampus) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text:
            "Cannot proceed on creating new fund source. Please select a fund cluster and campus",
        });
        return;
      }
      this.onReset();
      this.form.fundClusterId = this.selectedCluster.id;
      this.modalTitle = "Create New Fund Source";
      this.$bvModal.show("modal-standard");
    },
    setDate(date) {
      const nDate = new Date(
        new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60 * 1000
      );
      return nDate.toISOString();
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.form.$invalid) {
        return;
      } else {
        this.pageLoader(true);
        this.form.agencyID = this.agencyID;
        this.form.expiry = this.setDate(this.form.expiry);
        this.form.campusId = this.selectedCampus;
        const nDate = new Date(
          new Date(this.form.expiry).getTime() -
          new Date(this.form.expiry).getTimezoneOffset() * 60 * 1000
        );

        const nData = JSON.parse(JSON.stringify(this.form));
        nData.agencyID = this.agencyID;
        nData.expiry = nDate.toISOString();
        if (this.form.id > 0) {
          this.$store
            .dispatch("fundsource/UpdateFundSource", nData)
            .then((res) => {
              // this.active.splice(this.indexSelected, 1, res.data);
              this.selectCluster(res.data.fundClusterId);
              this.getFavorites();
              this.pageLoader(false);
              this.$bvModal.hide("modal-standard");
              this.showToast("Successfully updated", "success");
              this.onReset();
            })
            .catch(() => {
              this.pageLoader(false);
              this.$bvModal.hide("modal-standard");
              this.showToast("Something went wrong. Cannot update Fund Source", "error");
              // this.alert = { type: "danger", message: "Something went wrong!" };
            });
        } else {
          // console.log(this.form.fundClusterId);
          this.$store
            .dispatch("fundsource/CreateFundSource", nData)
            .then((res) => {
              // this.active.push(res.data);
              this.selectCluster(res.data.fundClusterId);
              this.pageLoader(false);
              this.$bvModal.hide("modal-standard");
              this.showToast("Successfully added", "success");
              this.onReset();
            })
            .catch(() => {
              this.$bvModal.hide("modal-standard");
              this.showToast("Something went wrong. Cannot create Fund Source", "error");
            });
        }
      }
    },
    hideModal() {
      this.$bvModal.hide("modal-standard");
    },
    onReset() {
      this.submitted = false;
      this.form = {
        id: 0,
        uacs: "",
        sourceName: "",
        shortName: "",
        description: "",
        bankName: "",
        accountNumber: "",
        fundClusterId: null,
        address: "",
        expiry: Date.parse(
          new Date(Number(this.$store.getters["data/getCycle"]), 11, 31)
        ),
        hasExpiry: false,
        fundsAvailableSignatory: "",
        fundsAvailableSignatoryPosition: "",
      };
      this.fundCluster = "";
    },
    updateItem(props) {
      this.form = cloneDeep(props);
      if (this.form.expiry) {
        this.form.expiry = Date.parse(new Date(this.form.expiry));
      }
      this.fundCluster = cloneDeep(props.fundCluster);
      this.indexSelected = this.active.indexOf(props); //get index of selected item (active)
      this.modalTitle = "Update Fund Source";
      this.$bvModal.show("modal-standard");
    },
    deleteItem(props) {
      // console.log(props);
      var index = this.active.indexOf(props);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("fundsource/DeleteFundSource", props.id)
            .then((res) => {
              if (res.status == 204) {
                this.active.splice(index, 1);
                // this.alert = {
                //   type: "success",
                //   message: "Successfully deleted",
                // };
                this.showToast("Successfully deleted", "success");
              }
            })
            .catch(() => {
              this.showToast("Something went wrong. Cannot delete Fund Source", "error");
              // this.alert = { type: "danger", message: "Cannot be deleted!" };
            });
        }
      });
    },
    onSelectFC(value) {
      this.form.fundClusterId = value.id;
    },
    selectFundSourceId(value) {
      this.transaction.fundSourceId = value;
    },
    // selectCampus(value) {
    //   if (!value) {
    //     return;
    //   }
    //   this.form.campusId = this.selectedCampus;

    //   this.selectCluster(this.selectedClusterFilter);
    //   this.selectedCampusInfo = this.campusAccessList.find((x) => x.value == value).text;
    // },
    async selectCluster(value) {
      if (!this.selectedCampus) {
        return;
      }
      this.transaction.fundSourceId = null;
      this.selectedFundSource = null;
      this.fundSourceBalance = 0;
      // this.selectedCluster = value;
      this.form.fundClusterId = value;
      this.transactionTable = [];
      if (!value) {
        // this.tableData = this.alltableData;
        this.active = [];
        this.expired = [];
        this.selectedCluster = null;
        return;
      }
      try {
        this.isActiveLoading = true;
        this.isExpiredLoading = true;
        const active = await this.$store.dispatch("fundsource/getActiveFundSource", {
          fundClusterId: value,
          cycle: this.cycle,
          campusId: this.selectedCampus,
        });
        if (active.data.error) {
          this.showToast(active.data.errorMessage, "error");
          return;
        }
        // check if active.data.id is in this.favorites
        active.data.forEach((item) => {
          if (this.favorites.find((fav) => fav.id === item.id)) {
            item.isFavorite = true;
          } else {
            item.isFavorite = false;
          }
        });
        this.active = active.data;
        this.isActiveLoading = false;

        this.allTransferOption = active.data.map((obj) => ({
          value: obj.id,
          text: `${obj.uacs} | ${obj.sourceName}`,
          cluster: obj.fundClusterId,
        }));

        const expired = await this.$store.dispatch("fundsource/getExpiredFundSource", {
          fundClusterId: value,
          campusId: this.selectedCampus,
        });
        if (expired.data.error) {
          this.showToast(expired.data.errorMessage, "error");
          return;
        }
        expired.data.forEach((item) => {
          if (this.favorites.find((fav) => fav.id === item.id)) {
            item.isFavorite = true;
          } else {
            item.isFavorite = false;
          }
        });
        this.expired = expired.data;
        this.isExpiredLoading = false;
        const cluster = await this.$store.dispatch(
          "fundcluster/GetSingleFundCluster",
          value
        );
        this.selectedCluster = cluster.data;
        // console.log(this.selectedCluster);
      } catch (e) {
        this.showToast("Something went wrong! Cannot retrieve Fund sources.", "error");
        this.isExpiredLoading = false;
        this.isActiveLoading = false;
      }
    },
    selectClustertoTransfer() {
      this.pageLoader(true);
      if (!this.selectedClusterOptionForTransfer || !this.selectedcOption) {
        this.pageLoader(false);
        this.transferOption = [];
        return;
      }
      this.$store
        .dispatch("fundsource/getActiveFundSource", {
          fundClusterId: this.selectedClusterOptionForTransfer,
          cycle: this.cycle,
          campusId: this.selectedcOption,
        })
        .then((response) => {
          const data = response.data.map((obj) => ({
            value: obj.id,
            text: obj.sourceName,
            cluster: obj.fundClusterId,
          }));
          this.transferOption = data.filter(
            (obj) => obj.value != this.selectedFundSource
          );
          this.pageLoader(false);
        })
        .catch(() => {
          this.pageLoader(false);
          this.showToast(
            "Something went wrong. Cannot fetch active Fund sources",
            "error"
          );
        });
    },
    viewOE(id) {
      this.$router.push(`/finance/expenditures/${id}`);
    },
    processActualCash(data) {
      this.acModal.show = true;
      this.actual = {
        id: data.id,
        bank: data.bankName,
        accountNumber: data.accountNumber,
        uacs: data.uacs,
        sourceName: data.sourceName,
        actualCashBalance: data.actualCashBalance,
        isExpired: data.hasExpiry ? this.checkExpiry(data.expiry) : false,
      };
      this.pageLoader(true);
      this.$store
        .dispatch("actualcash/getActualCashTransactions", {
          fundSourceId: data.id,
          cycle: this.cycle,
        })
        .then((response) => {
          this.actualCashTransactions = response.data;
          this.pageLoader(false);
        })
        .catch((error) => {
          this.pageLoader(false);
          this.showToast(
            "Something went wrong! Cannot fetch Actual Cash Transactions",
            "error"
          );
        });
    },
    viewTransactions(data) {
      this.fsModal.title = `Transactions and Details for ${data.sourceName}`;
      this.fsModal.show = true;
      this.pageLoader(true);
      this.transferOption = [];
      this.transaction.fundSourceId = data.id;
      this.selectedFundSource = data.id;
      this.selectedFundSourceName = data.sourceName;
      this.fundSourceBalance = data.balance;
      this.isExpired = data.hasExpiry ? this.checkExpiry(data.expiry) : false;

      this.$store
        .dispatch("fundsource/GetTransactionByFundSource", data.id)
        .then((res) => {
          this.transactionTable = res.data;
          this.pageLoader(false);
        })
        .catch(() => {
          this.pageLoader(false);
          this.showToast("Something went wrong. Cannot view transactions", "error");
          // this.alert = { type: "danger", message: "Something went wrong!" };
        });
    },
    updateActual(data) {
      if (data.type === "debit") {
        this.actual.actualCashBalance += data.data.debit;
        this.active.find(
          (item) => item.id === data.data.fundSourceId
        ).actualCashBalance += data.data.debit;
      }
      if (data.type === "credit") {
        this.actual.actualCashBalance -= data.data.credit;
        this.active.find(
          (item) => item.id === data.data.fundSourceId
        ).actualCashBalance -= data.data.credit;
      }
      this.actualCashTransactions.push(data.data);
      this.showToast("Successfully added actual cash transaction", "success");
    },
    viewSchedule(data) {
      this.utilizationTitle = `Utilization Schedule for ${data.sourceName} for ${this.cycle}`;
      this.$bvModal.show("utilization");
      this.pageLoader(true);
      this.$store
        .dispatch("fundsource/getUtilizationSchedule", {
          fundSourceId: data.id,
          cycle: this.cycle,
        })
        .then((response) => {
          this.utilizationSchedule = response.data;
          this.pageLoader(false);
        })
        .catch(() => {
          this.pageLoader(false);
          this.showToast(
            "Something went wrong! Cannot fetch utilization schedule",
            "error"
          );
        });
    },
    toggleTableViews(str) {
      this.toggleTables = str;
    },
    printAllotment(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/ObjectOfExpenditure/Allotment/FundSource",
        routeVariables: [id, this.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    printUtilization(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Utilization",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    printObligations(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Obligations",
        routeVariables: [this.cycle, id],
      });
      this.$bvModal.show("print-options-modal");
    },
    printDisbursement(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Disbursement",
        routeVariables: [this.cycle, id],
      });
      this.$bvModal.show("print-options-modal");
    },
    printAllocation(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Object/Allocation",
        routeVariables: [this.cycle, id],
      });
      this.$bvModal.show("print-options-modal");
    },
    viewObligations(row) {
      this.$refs.obligation.getData(row);
      this.$bvModal.show("fs-obligation-modal");
    },
    viewDisbursements(row) {
      this.$refs.disbursement.getData(row);
      this.$bvModal.show("fs-disbursement-modal");
    },
  },
};
</script>

<template>
  <Layout @changeCycle="changeCycle" @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
      <b-modal 
        title-class="font-18"
        hide-footer
        v-model="transactionModal"
        :title="transactionModalTitle"
      >
        <b-alert :show="modalAlert.show" :variant="modalAlert.type">{{ modalAlert.message }}</b-alert>
        <div v-if="transactionType === 'transfer'">
          <div class="mb-1">
            <small class="d-block">Transfer from: </small>
            <h5 class="text-info">{{ selectedFundSourceName }}</h5>
          </div>
          <div>
            <small>Amount available: </small>
            <h5 class="text-yellow">{{ formatCurrency(fundSourceBalance) }}</h5>
          </div>
          <hr />
        </div>
        <div class="mb-3">
          <div class="mb-3" v-if="transactionType === 'transfer'">
            <label for="date">Select campus</label>
            <b-form-select 
              :options="cOptions"
              v-model="selectedcOption"
              @change="selectClustertoTransfer"
              class="form-select form-select-sm text-warning"
            ></b-form-select>
          </div>
          <div class="mb-3" v-if="transactionType === 'transfer'">
            <label for="date">Select fund cluster</label>
            <b-form-select 
              :options="clusterOptionforTransfer"
              v-model="selectedClusterOptionForTransfer"
              @change="selectClustertoTransfer"
              class="form-select form-select-sm text-warning"
            ></b-form-select>
          </div>
          <div v-if="transactionType === 'transfer'" class="mb-3">
            <label for="date">Transfer to</label>
            <b-form-select 
              v-model="transaction.fundSourceId"
              :options="transferOption"
              @change="selectFundSourceId"
              placeholder="Select Fund Source..."
              class="form-select form-select-sm text-warning"
              :class="{
                'is-invalid': submitted && $v.transaction.fundSourceId.$error,
              }"></b-form-select>
            <div v-if="submitted && $v.transaction.fundSourceId.$error"
                class="invalid-feedback">
              <span v-if="!$v.transaction.fundSourceId.required">This value is required.</span>
            </div>
          </div>
          <div v-if="transactionType !== 'transfer'">
            <label for="date">Transaction Date</label>
            <date-picker 
              v-model="transaction.date"
              :first-day-of-week="1"
              lang="en"
              type="datetime"
              value-type="timestamp"
              format="YYYY-MM-DD hh:mm a"
              :class="{
                'is-invalid': submitted && $v.transaction.date.$error,
              }">
            </date-picker>
            <div v-if="submitted && $v.transaction.date.$error"
                class="invalid-feedback">
              <span v-if="!$v.transaction.date.required">This value is required.</span>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description</label>
          <b-form-input 
            v-model="transaction.description"
            id="description"
            placeholder="Enter description"
            class="form-control"
            autocomplete="off"
            :class="{
              'is-invalid': submitted && $v.transaction.description.$error,
            }"
          >
          </b-form-input>
          <div v-if="submitted && $v.transaction.description.$error"
              class="invalid-feedback">
            <span v-if="!$v.transaction.description.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="amount">Amount</label>
          <masked-input 
            autocomplete="off"
            type="text"
            v-model="transaction.amount"
            placeholder="Enter Amount..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.transaction.amount.$error,
            }"
            :mask="currencyMask"
          ></masked-input>
          <div v-if="submitted && $v.transaction.amount.$error"
              class="invalid-feedback">
            <span v-if="!$v.transaction.amount.required">This value is required.</span>
          </div>
        </div>
        <div class="modal-footer">
          <b-button variant="primary" @click="saveTransaction"> Save </b-button>
          <b-button variant="link" @click="hideTransaction"> Close </b-button>
        </div>
      </b-modal>
      <b-modal 
        id="modal-standard"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
      >
        <form 
          @submit.prevent="onCreate"
          @reset="onReset"
          ref="fsForm"
        >
          <div class="mb-2" v-if="selectedCluster">
            <p>
              <span>Adding New Fund Source for </span>
              <strong class="text-info">{{ selectedCluster.shortName }} - {{ selectedCluster.cluster }}</strong>
              under
              <strong class="text-warning">{{ selectedCampusInfo }}</strong>
            </p>
          </div>
          <div class="mb-3">
            <label for="sourceName">Source Name</label>
            <b-form-input 
              id="sourceName"
              type="text"
              v-model="form.sourceName"
              placeholder="Enter Source Name..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.sourceName.$error,
              }"
            ></b-form-input>
            <div v-if="submitted && $v.form.sourceName.$error" class="invalid-feedback">
              <span v-if="!$v.form.sourceName.required">This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="shortName">Short Name</label>
            <b-form-input 
              id="shortName"
              type="text"
              v-model="form.shortName"
              placeholder="Enter Short Name..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.shortName.$error,
              }"
            ></b-form-input>
            <div v-if="submitted && $v.form.shortName.$error" class="invalid-feedback">
              <span v-if="!$v.form.shortName.required">This value is required.</span>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="bankName">Bank Name</label>
              <b-form-input 
                id="bankName"
                type="text"
                v-model="form.bankName"
                placeholder="Enter Bank Name..."
                class="form-control"
              ></b-form-input>
            </div>
            <div class="col-md-6">
              <label for="acctNo">Account Number</label>
              <b-form-input 
                id="acctNo"
                type="text"
                v-model="form.accountNumber"
                placeholder="Enter Account Number..."
                class="form-control"
              >
              </b-form-input>
            </div>
          </div>
          <div class="mb-3">
            <label for="address">Address</label>
            <b-form-input 
              id="address"
              type="text"
              v-model="form.address"
              placeholder="Enter Address..."
              class="form-control"
            ></b-form-input>
          </div>
          <div class="mb-3">
            <input 
              class="form-check-input"
              type="checkbox"
              id="horizontalLayout-Check"
              v-model="form.hasExpiry" />&nbsp;&nbsp;
            <label class="form-check-label" for="horizontalLayout-Check">Validity</label>
            <date-picker 
              v-if="form.hasExpiry"
              v-model="form.expiry"
              :first-day-of-week="1"
              lang="en"
              value-type="timestamp"
              format="YYYY-MM-DD"
              placeholder="Enter Validity Date..."
            ></date-picker>
          </div>
          <div class="mb-3">
            <label class="form-check-label mb-2" for="signatory">Signatory</label>
            <b-form-input
              id="signatory"
              type="text"
              v-model="form.fundsAvailableSignatory"
              placeholder="Enter Signatory..."
              class="form-control"
            ></b-form-input>
          </div>
          <div class="mb-3">
            <label class="form-check-label mb-2" for="signatory-position">Signatory Position</label>
            <b-form-input
              id="signatory-position"
              type="text"
              v-model="form.fundsAvailableSignatoryPosition"
              placeholder="Enter Signatory Position..."
              class="form-control"
            ></b-form-input>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary">Save changes</button>
            <button type="button" class="btn btn-secondary" @click="hideModal">Close</button>
          </div>
        </form>
      </b-modal>
    <div class="row">
      <div class="col-12">
        <b-alert :show="alert.type === 'success'" dismissible @dismissed="alert.type = ''" variant="success">
          <i class="mdi mdi-check-all me-2"></i>{{ alert.message }}
        </b-alert>
        <b-alert :show="alert.type === 'danger'" dismissible @dismissed="alert.type = ''" variant="danger">
          <i class="mdi mdi-block-helper me-2"></i>{{ alert.message }}
        </b-alert>
        <b-alert :show="alert.type === 'warning'" dismissible @dismissed="alert.type = ''" variant="warning">
          <i class="mdi mdi-alert-outline me-2"></i>{{ alert.message }}
        </b-alert>
      </div>
      <div class="col-md-12"
          style="z-index: 1">
        <FundSourceFavorites :fundSource="favorites"
                            @view-transactions="viewTransactions"
                            @process-actual-cash="processActualCash"
                            @update-item="updateItem"
                            @delete-item="deleteItem"
                            @view-oe="viewOE"
                            @printAllotment="printAllotment"
                            @printUtilization="printUtilization"
                            @printObligations="printObligations"
                            @printDisbursement="printDisbursement"
                            @printAllocation="printAllocation"
                            @view-schedule="viewSchedule"
                            @remove-favorites="removeFavorite"
                            @view-disbursements="viewDisbursements"
                            @view-obligations="viewObligations" />
      </div>
      <div class="col-md-12">
        <b-card>
          <b-card-title>Sources</b-card-title>
          <b-card-text>
            <div class="row my-3">
              <div class="col-md-10 col-12">
                <div class="d-flex flex-row mb-2 mb-md-0">
                  <b-form-group label="Cluster:">
                    <b-form-select v-model="selectedClusterFilter"
                                  :options="clusterOptions"
                                  @change="selectCluster"
                                  placeholder="Select cluster..."
                                  class="form-select form-select-sm">
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="col-md-2 col-12 text-md-end">
                <button type="button"
                        @click="addFS()"
                        class="btn btn-md btn-md-md btn-info btn-block btn-md-inline">
                  <i class="bx bx-plus fs-6 align-middle me-2"></i>Create New
                </button>
              </div>
            </div>

            <b-tabs content-class="mt-4"
                    nav-class="nav-tabs-custom">
              <b-tab>
                <template #title>
                  <i class="bx bx-calendar-check text-info font-size-16 align-middle me-2"></i>
                  <span class="align-middle font-size-16">Active</span>
                </template>
                <b-alert :show="active.length == 0"
                        variant="info">No list to be displayed. Please select fund cluster above.</b-alert>

                <FundSources :tableData="active"
                            :isLoading="isActiveLoading"
                            :campusId="selectedCampus"
                            @transferCampus="transferCampus"
                            @view-transactions="viewTransactions"
                            @process-actual-cash="processActualCash"
                            @update-item="updateItem"
                            @delete-item="deleteItem"
                            @view-oe="viewOE"
                            @printAllotment="printAllotment"
                            @printUtilization="printUtilization"
                            @printObligations="printObligations"
                            @printDisbursement="printDisbursement"
                            @printAllocation="printAllocation"
                            @view-schedule="viewSchedule"
                            @remove-favorite="removeFavorite"
                            @add-favorite="addFavorite"
                            @view-obligations="viewObligations"
                            @view-disbursements="viewDisbursements" />
              </b-tab>
              <b-tab>
                <template #title>
                  <i class="bx bx-calendar-x text-danger align-middle me-2 font-size-16"></i>
                  <span class="align-middle font-size-16">Expired</span>
                </template>
                <b-alert :show="expired.length == 0"
                        variant="info">No list to be displayed. Please select fund cluster above.</b-alert>

                <FundSources :tableData="expired"
                            :campusId="selectedCampus"
                            :isLoading="isExpiredLoading"
                            @view-transactions="viewTransactions"
                            @update-item="updateItem"
                            @delete-item="deleteItem"
                            @view-oe="viewOE" />
              </b-tab>
            </b-tabs>
            <!-- Expired -->
          </b-card-text>
        </b-card>
      </div>
      <!-- modal here -->
      <b-modal size="xl"
              v-model="fsModal.show"
              :title="fsModal.title"
              hide-footer>
        <FundSourceTransactions :transactionTable="transactionTable"
                                :selectedFundSourceName="selectedFundSourceName"
                                :fundSourceBalance="fundSourceBalance"
                                :tableBusy="tableBusy"
                                :selectedFundSource="selectedFundSource"
                                :isExpired="isExpired"
                                @addTransaction="addTransaction"
                                @transferFund="transferFund" />
      </b-modal>
      <b-modal size="xl"
              v-model="acModal.show"
              title="Actual Cash Transactions"
              hide-footer>
        <ActualCashTransactions :transactionTable="actualCashTransactions"
                                :fundSource="actual"
                                :cycle="cycle"
                                @update-actual="updateActual" />
      </b-modal>
      <b-modal id="utilization"
              :title="utilizationTitle"
              size="xl"
              hide-footer>
        <div class="row">
          <div class="col-md-6">
            <b-card>
              <b-card-title>
                Quarter 1 -
                <span class="text-info">{{
                  formatCurrency(utilizationSchedule.q1)
                }}</span>
              </b-card-title>
              <b-card-text>
                <div class="table-responsive">
                  <table class="table table-bordered border-primary mb-0 mt-3">
                    <thead class="table-light">
                      <tr>
                        <th class="text-center">January</th>
                        <th class="text-center">February</th>
                        <th class="text-center">March</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.january) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.february) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.march) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-text>
            </b-card>
          </div>
          <div class="col-md-6">
            <b-card>
              <b-card-title>
                Quarter 2 -
                <span class="text-info">{{
                  formatCurrency(utilizationSchedule.q2)
                }}</span>
              </b-card-title>
              <b-card-text>
                <div class="table-responsive">
                  <table class="table table-bordered border-primary mb-0 mt-3">
                    <thead class="table-light">
                      <tr>
                        <th class="text-center">April</th>
                        <th class="text-center">May</th>
                        <th class="text-center">June</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.april) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.may) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.june) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-card>
              <b-card-title>
                Quarter 3 -
                <span class="text-info">{{
                  formatCurrency(utilizationSchedule.q3)
                }}</span>
              </b-card-title>
              <b-card-text>
                <div class="table-responsive">
                  <table class="table table-bordered border-primary mb-0 mt-3">
                    <thead class="table-light">
                      <tr>
                        <th class="text-center">July</th>
                        <th class="text-center">August</th>
                        <th class="text-center">September</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.july) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.august) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.september) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-text>
            </b-card>
          </div>
          <div class="col-md-6">
            <b-card>
              <b-card-title>
                Quarter 4 -
                <span class="text-info">{{
                  formatCurrency(utilizationSchedule.q4)
                }}</span>
              </b-card-title>
              <b-card-text>
                <div class="table-responsive">
                  <table class="table table-bordered border-primary mb-0 mt-3">
                    <thead class="table-light">
                      <tr>
                        <th class="text-center">October</th>
                        <th class="text-center">November</th>
                        <th class="text-center">December</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.october) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.november) }}
                        </td>
                        <td class="text-center text-warning">
                          {{ formatCurrency(utilizationSchedule.december) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
      </b-modal>
      <!-- modal here -->
    </div>
    <print-options ref="printOpt"></print-options>
    <disbursement-modal ref="disbursement"></disbursement-modal>
    <obligation-modal ref="obligation"></obligation-modal>
  </Layout>
</template>

<style>
.style-chooser {
  width: 80%;
  font-size: 11px;
}

.simplebar-mask,
.simplebar-content-wrapper {
  overflow: hidden !important;
}

.ps {
  height: 500px;
}
</style>
